import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import { analyticsTracker } from "@utils/analytics";
import { BetBuilderPickActionsTypeEnum } from "@data-types/analytics-tracker/QuickPlayInteractionTypeEnum";
import BetBuilderPicksCard from "./BetBuilderPicksCard";
import { useRootAppStore } from "@hooks";
import QuickPlayEventResultAndTime from "@features/quick-play/shared/QuickPlayEventResultAndTime";

export default observer(function BetBuilderPicksSliderItem(props: {
	BBPick: BetBuilderPick;
	index: number;
	activatePopup: (id: string, index: number, show: boolean) => void;
}) {
	const { t } = useTranslation();

	const rootStore = useRootAppStore();

	const event =
		rootStore.quickPlayStore.betBoosterStore.eventsResultHubStore.getEvent(
			props.BBPick.eventId
		);

	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();

		analyticsTracker.trackQuickPlayInteraction(
			BetBuilderPickActionsTypeEnum.PickClick
		);

		props.activatePopup(props.BBPick.id, props.index, false);
	};

	return (
		<div className="carousel__item carousel--most__item">
			<div
				onClick={handleClick}
				className="carousel__slide carousel--most__slide"
			>
				<div className="card card--qp card--qp--nowrap card--bbp card--bbp--nowrap">
					<div className="card__header card--qp__header card--bbp__header">
						<QuickPlayEventResultAndTime
							event={event}
							startTime={props.BBPick.startTime}
							isTextInline
						/>

						{props.BBPick.isLive && (
							<span className="card--qp__tag tag tag--tny tag--live--ghost tag--bolder">
								{t<string>("COMMON.LIVE")}
							</span>
						)}
					</div>

					<div className="card__body card--qp__body card--bbp__body">
						<BetBuilderPicksCard
							BBPick={props.BBPick}
							maxOffers={2}
						/>
					</div>
				</div>
			</div>
		</div>
	);
});
